var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('UserSurveys',{attrs:{"user-id":_vm.$route.params.id}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }